import React from "react";
import {Typography} from "@material-ui/core";

const item_list = [
    {description: 'This agreement governs your use of the Alexa skill on an Alexa enabled device, like Amazon Echo (‘the Skill’).', key: 0},
    {description: 'By linking the Skill, you agree to the following terms and conditions. These should be read in conjunction with the common sense.', key: 1},
    {description: 'This skill communicates with the Oura Ring API on your behalf. Consenting happens when you use Account Linking and hit Agree', key: 2},
    {description: 'You can revoke your consent by unlinking the skill in your Alexa account or App', key: 3},
    {description: 'The skill only uses your daily summaries (activity, readiness, sleep) and has no access to your personal information and your email address, by your own consent', key: 4},
    {description: 'Your daily summaries are accessed and processed when you invoke an Intent (e.g. ask Alexa a question), but are not saved anywhere', key: 5},
    {description: 'When you request something Alexa can show you (e.g. a graph, on a device with a display, or a card in your app), it will be stored in Amazon S3 and deleted after one day. Graphs are returned to you using a signed URL which is valid for one hour, and is returned only to you', key: 6},
    {description: 'An endeavour is made to make sure the information we provide is correct but you should not rely on any of the information.', key: 7},
];

export default function PrivacyPolicy() {
    return (
    <div>
        <Typography variant="h4">Privacy Policy</Typography>
        <ol>

            {item_list.map(question => {
                return (
                    <li key={question.key}>{question.description}</li>
                );
            })}

        </ol>
    </div>
    );
}

